import Heading from '@components/web/heading/Heading.tsx';
import { pricingPlan } from '@/pages/home/components/price/pricing.data.tsx';
import RFTrigger from '@/form/register/RFTrigger.tsx';

const Pricing = () => {
  return (
    <div id="prijzen" className="scroller">
      <Heading title="Prijzen" />
      <div className="container py-20">
        <div className="grid grid-cols-1">
          <div className="w-full max-w-[450px] mx-auto bg-[var(--mantine-primary-color-filled)] p-1">
            <div className="bg-white">
              <div className="border-b border-b-[#d3dae5] text-center shadow-[inset_0_-7px_6px_#f7f7f7] p-2">
                <h4 className="text-[30px]">{pricingPlan.title}</h4>
              </div>
              <div className="border-b border-b-[#d3dae5] shadow-[inset_0_-29px_20px_#f7f7f7] text-center px-[20px] py-[32px]">
                <h5 className="text-[80px] leading-[75px]">
                  {pricingPlan.price}
                </h5>
                <p className="text-[15px] mt-3">{pricingPlan.period}</p>
              </div>
              <div className="py-[17px] border-b border-b-[#d3dae5] text-center">
                <h6>{pricingPlan.guarantee}</h6>
              </div>
            </div>
            <div>
              <ul className="px-5 text-center">
                {pricingPlan.features.map((feature, index) => {
                  return (
                    <li
                      className="border-b border-b-[#768d9e] py-[10px] text-sm text-white text-shadow-[1px_1px_0px_#5a7917]"
                      key={index}
                      dangerouslySetInnerHTML={{ __html: feature }}
                    />
                  );
                })}
              </ul>
            </div>
            <div className="p-5 flex items-center justify-center">
              <RFTrigger
                btnProps={{ variant: 'white' }}
                title={pricingPlan.cta}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
